<template>
  <a-modal
    title="微信变现类型"
    :visible="visible"
    :confirm-loading="isLoading"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <!-- 表单 -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 变现类型 -->
      <a-form-item
        label="变现类型"
        name="wx_type"
        :rules="[{ required: true, message: '请选择变现类型' }]"
      >
        <a-radio-group v-model:value="formState.wx_type">
          <a-radio
            v-for="item in WXProfitTypes"
            :key="item.value"
            :value="item.value"
          >
            {{ item.text }}
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <!-- 是否存在会员 -->
      <a-form-item
        label="是否存在会员"
        name="wx_vip"
        :rules="[{ required: true, message: '请选择是否存在会员' }]"
      >
        <a-radio-group v-model:value="formState.wx_vip">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="2">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <!-- 微小剧ID -->
      <a-form-item
        label="微小剧ID"
        name="drama_ids_text"
        :rules="[
          { required: true, message: '请输入微小剧ID' },
          { validator: validatorDramaIds }
        ]"
      >
        <a-textarea
          v-model:value="formState.drama_ids_text"
          :rows="4"
          placeholder="支持多个ID，英文逗号间隔即可"
          :disabled="isLoading"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
import { WXProfitTypes } from '@/utils/constant'
import { projectWxSetSave } from '@/api/operate'

// emit
const emit = defineEmits(['success'])
// 表单实例
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 表单参数
const formState = reactive({
  // 微信变现类型：1-纯IAA；2-纯IAP；3-IAAP混合变现
  wx_type: 1, // 默认：纯IAA
  // 是否存在会员功能: 1-有；2-无
  wx_vip: 2, // 默认：否
  // 微小剧ID文本（逗号分隔）
  drama_ids_text: ''
})

// 显示
function showModal () {
  // 重置表单，设置默认值
  formState.wx_type = 1 // 默认：纯IAA
  formState.wx_vip = 2 // 默认：否
  formState.drama_ids_text = ''
  // 显示
  visible.value = true
}

// 关闭
function handleCancel () {
  if (!isLoading.value) {
    visible.value = false
    resetFields()
  }
}

// 重置
function resetFields () {
  RefForm.value?.resetFields()
}

// 验证微小剧ID
function validatorDramaIds (rule, value) {
  // 如果值为空，让 required 规则来处理，这里直接通过
  if (!value || value.trim() === '') {
    return Promise.resolve()
  }
  
  // 按逗号分割
  const ids = value.split(',').map(id => id.trim()).filter(id => id !== '')
  
  if (ids.length === 0) {
    return Promise.reject('请输入有效的微小剧ID')
  }
  
  if (ids.length > 50) {
    return Promise.reject('最多只能输入50个ID')
  }
  
  // 验证每个ID是否为数字
  for (let i = 0; i < ids.length; i++) {
    if (!/^\d+$/.test(ids[i])) {
      return Promise.reject('ID必须为数字')
    }
  }
  
  return Promise.resolve()
}

// 提交
function handleOk () {
  RefForm.value.validate().then(() => {
    isLoading.value = true
    
    // 将逗号分隔的ID文本转换为数组
    const dramaIds = formState.drama_ids_text
      .split(',')
      .map(id => id.trim())
      .filter(id => id !== '')
      .map(id => parseInt(id, 10))
    
    const params = {
      wechat_drama_ids: dramaIds,
      wx_type: formState.wx_type,
      wx_vip: formState.wx_vip
    }
    
    projectWxSetSave(params).then(res => {
      isLoading.value = false
      const { code, msg } = res
      if (code === 0) {
        message.success('操作成功')
        handleCancel()
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    }).catch(err => {
      isLoading.value = false
      message.error('操作失败')
      console.error(err)
    })
  }).catch((err) => {
    console.log(err)
  })
}

// 抛出
defineExpose({
  showModal
})

</script>

<style scoped>
</style>

